import { getJson } from './http';
import type { ProjectsHome } from '../../views/CompanyDashboard/types';

// CO-962: the home Projects group, from Task Boards (open, overdue, needs attention for the caller).
export async function fetchProjectsHome(signal?: AbortSignal): Promise<ProjectsHome> {
  return await getJson<ProjectsHome>('/TaskBoard/Dashboard/Home', undefined, signal);
}
